class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productCard = this;
    this.desktopVariantTrigger = this.querySelector('.card__desktop-variant-trigger')

    this.desktopVariantTrigger.addEventListener('click', this.triggerDesktopModal.bind(this))
    this.addEventListener('mouseleave', this.hideVariantsModal.bind(this))
  }

  triggerDesktopModal() {
    this.classList.add('variants-modal-active')
  }

  hideVariantsModal() {
    this.classList.remove('variants-modal-active')
  }
}

customElements.define('product-card', ProductCard);
